import { FREESPIN, FREEBET } from '../../constants/index.js';

const itemCostHelper = ({ ppAmount, playerPointCost, playerPointsCost, playersPointCost }) => {
	if (ppAmount || ppAmount === 0) return ppAmount.toString();
	if (playerPointCost || playerPointCost === 0) return playerPointCost.toString();
	if (playerPointsCost || playerPointsCost === 0) return playerPointsCost.toString();
	if (playersPointCost || playersPointCost === 0) return playersPointCost.toString();
};

const getDetailViewItemButtonText = (item, itemCost, translations) => {
	return item.type === FREESPIN
		? translations.SHOP_GET_FREESPIN
		: item.type === FREEBET
			? translations.SHOP_GET_FREEBET
			: item.TYPE === FREEBET && itemCost > 0
				? translations.MARKETPLACE_BUY_WITH_POINTS
				: translations.MARKETPLACE_GET_BONUS;
};

const filterItemsBySelectedSplitCategory = (allItems, category) => {
	return allItems.filter(item => item.productCategoryCodes?.includes(category));
};
const campaignMatchingSplitCategory = (campaignCategory, splitCategory) => campaignCategory?.includes(splitCategory);

const myActivitiesSplitItemsChecker = (filteringCondition, allItems, category) =>
	filteringCondition ? filterItemsBySelectedSplitCategory(allItems, category) : allItems;

// See BANJO-1786
// paymentMethodsIds: [],
// paymentMethodIdsStr: '',
/**
 * [paymentMethodsHelper description]
 * @param  {[shop-object]} item [description]
 * @return {[string]}      ['ALL' | '1,2,3,4,5']
 */
const paymentMethodsHelper = item => {
	let bonusPaymentMethods = 'ALL';
	if (item.item && item.item.paymentMethodsIds !== undefined && item.item.paymentMethodsIds.length > 0) {
		bonusPaymentMethods = item.item.paymentMethodsIds.join();
	} else if (item.item && item.item.paymentMethodIdsStr) {
		bonusPaymentMethods = item.item.paymentMethodIdsStr;
	}

	if (item && item.paymentMethodsIds !== undefined && item.paymentMethodsIds > 0) {
		bonusPaymentMethods = item.paymentMethodsIds.join();
	} else if (item.paymentMethodIdsStr) {
		bonusPaymentMethods = item.paymentMethodIdsStr;
	}

	return bonusPaymentMethods;
};

export {
	itemCostHelper,
	getDetailViewItemButtonText,
	paymentMethodsHelper,
	filterItemsBySelectedSplitCategory,
	myActivitiesSplitItemsChecker,
	campaignMatchingSplitCategory
};
